
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService{
  constructor() { }
  // 验证手机号码
  tellPhoneNumberValidator(control: FormControl): any {
    if (!control.value) {
        return { required: true };
    } else {
        const regs = /^1(3|4|5|6|7|8|9)\d{9}$/;
        const valid = regs.test(control.value);
        return valid ? null : {tellPhoneNumberValidator: true};
    }
  }
  // 验证固话号码
  phoneNumberValidator(control: FormControl): any {
    if (!control.value) {
        return { required: true };
    } else {
        const regs = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
        const valid = regs.test(control.value);
        return valid ? null : {phoneNumber: true};
    }
  }
  // 验证数字
  numberValidator(control: FormControl): any {
    if (!control.value) {
        return { required: true };
    } else {
        const regs = /^[0-9]*$/;
        const valid = regs.test(control.value);
        return valid ? null : {intNumber: true};
    }
  }
  // 验证数字大于0
  numberGreaterThanZeroValidator(control: FormControl): any {
    if (!control.value) {
        return { required: true };
    } else {
        const regs = /^[1-9]\d*$/;
        const valid = regs.test(control.value);
        return valid ? null : {intNumber: true};
    }
  }
  // 验证数字大于0
  twoDecimalValidator(control: FormControl): any {
    if (!control.value) {
        return { required: true };
    } else {
        const regs = /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*)|0)$/;
        const valid = regs.test(control.value);
        return valid ? null : {intNumber: true};
    }
  }
  // 验证数字为一位小数
  oneDecimalValidator(control: FormControl): any {
    if (!control.value) {
        return { required: true };
    } else {
        const regs = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,1})?$/;
        const valid = regs.test(control.value);
        return valid ? null : {intNumber: true};
    }
  }
}

